import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ClientDocumentTitle} from 'src/pages/Modules/Clients/shared/clientHelpers';
import {ClientForm} from 'src/pages/Modules/Clients/shared/ClientForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const ClientEditPage = () => {
  useSetDocumentTitle(ClientDocumentTitle);
  const {clientId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Clients}>
      <ClientForm id={Number(clientId)} mode="edit" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ClientsEdit(':clientId'),
  element: <ClientEditPage />,
  module: ModuleEnum.Clients,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
